import { render, staticRenderFns } from "./SuggestionBarList.vue?vue&type=template&id=58e26f9f&"
import script from "./SuggestionBarList.vue?vue&type=script&lang=js&"
export * from "./SuggestionBarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports